/**
 * Redux dropDown 各下标约定为下拉数组；在请求失败或长度不足时用于兜底，避免 .slice / .map 抛错。
 */
export function dropDownRow(dd, index) {
  const d = dd == null ? [] : dd;
  if (Array.isArray(d[index]) && d[index].length > 0) return d[index];
  return [{ code: "", name: "" }];
}

export function dropDownRowSlice(dd, index) {
  return dropDownRow(dd, index).slice(1);
}

export function dropDownServerBase(dd) {
  const d = dd == null ? [] : dd;
  if (!d.length) return "/api-backend/";
  const last = d[d.length - 1];
  if (typeof last !== "string" || !last) return "/api-backend/";
  if (/^https?:\/\//i.test(last))
    return last.endsWith("/") ? last : last + "/";
  return last.endsWith("/") ? last : last + "/";
}
